<div class="full-popup-head">
  <div class="full-popup-title flex"><em class="modal-title-icon icon-user"></em>{{ data.title }}</div>
  <ng-container *ngIf="isViewMode && userView?.no">
    <ng-container *ngIf="hasManagePermission">
      <button
        [disabled]="!userView.active"
        type="button"
        class="btn btn-header-button d-none d-md-block"
        (click)="handleResetPassword()"
      >
        <em class="icon-reset-pass"></em>Reset Password
      </button>
      <button type="button" class="btn btn-header-button d-none d-md-block" (click)="handleChangeStatusUser()">
        <span *ngIf="userView.active; else isDeactivate"> <em class="icon-deactivate"></em>Deactivate </span>
        <ng-template #isDeactivate>
          <span><em class="icon-activate"></em>Activate</span>
        </ng-template>
      </button>
    </ng-container>
    <button type="button" class="btn btn-header-button d-none d-md-block" (click)="showHistory()">
      <em class="icon-history"></em>History
    </button>
  </ng-container>
  <div class="full-popup-close">
    <a aria-label="Close" class="close" (click)="onExit()">
      <em class="icon-close"></em>
    </a>
  </div>
  <div class="clearfix"></div>
</div>
<div>
  <ng-container *ngIf="isViewMode; else editForm">
    <div class="user-view" data-id="userView" *ngIf="userView">
      <div class="profile-header-card" data-id="profileHeaderCard">
        <div class="profile-header-main">
          <span class="profile-header-name" data-id="profileHeaderName">
            {{ userView.firstName }} {{ userView.lastName }} | {{ userView.localFirstName }}
            {{ userView.localLastName }}
          </span>
          <span [ngClass]="status | lowercase" class="user-status" data-id="profileHeaderStatus">
            {{ 'USER.STATUS.' + status | translate | titlecase }}
          </span>
        </div>

        <div class="profile-header-fields">
          <span class="field-item"
            >Employee ID :&nbsp;<span class="field-value">{{ userView.employeeCode || '-' }}</span></span
          >
          <span class="field-divider">|</span>
          <span class="field-item"
            ><em class="field-icon icon-merchant"></em>Merchant :&nbsp;
            <span class="field-value">{{ userView.merchant?.merchantName || '-' }}</span></span
          >
          <span class="field-divider">|</span>
          <span class="field-item"
            ><em class="field-icon icon-department"></em>Department :&nbsp;
            <span class="field-value">{{ departmentDisplay }}</span></span
          >
          <span class="field-divider">|</span>
          <span class="field-item"
            ><em class="field-icon icon-phone"></em>Mobile Phone :&nbsp;
            <span class="field-value">{{ mobilePhoneDisplay }}</span></span
          >
          <span class="field-divider">|</span>
          <span class="field-item"
            ><em class="field-icon icon-email"></em>Email :&nbsp;
            <span class="field-value">{{ userView.email || '-' }}</span></span
          >
        </div>

        <hr class="profile-header-divider" />

        <div class="role-row" data-id="roleTagBar">
          <span class="field-label">Role :</span>
          <span class="role-tag" *ngFor="let role of userView.roles; index as i" [attr.data-id]="'roleTag' + i">
            {{ roleDisplayName(role) }}
          </span>
        </div>
      </div>

      <div *ngIf="viewAuthorityError" class="store-authority-card" data-id="storeAuthorityError">
        <div class="authority-error-head">
          <span class="authority-error-accent"></span>
          <span class="authority-error-title">Store Authority</span>
        </div>
        <div class="authority-error">
          <span class="authority-error-message">
            <svg class="authority-error-icon" width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
              <circle cx="8" cy="8" r="7" fill="none" stroke="currentColor" stroke-width="1.5" />
              <path d="M8 4.5v4.2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
              <circle cx="8" cy="11.3" r="0.9" fill="currentColor" />
            </svg>
            Unable to load store authority. Please try again.
          </span>
          <button
            type="button"
            class="btn btn-standard authority-error-retry"
            data-id="storeAuthorityRetry"
            (click)="loadViewAuthorityScopes(userView.no)"
          >
            Retry
          </button>
        </div>
      </div>

      <ng-container *ngIf="viewAuthorityLevel && !viewAuthorityError">
        <div class="store-authority-card">
          <app-store-authority-viewer
            [level]="viewAuthorityLevel"
            [levelLabel]="authorityLevelLabel"
            [accessAllStores]="viewAuthorityLevel === authorityLevelAllStore"
            [scopeDetails]="viewScopeDetails"
            [storesView]="viewStoresForStoreLevel"
          ></app-store-authority-viewer>
        </div>
      </ng-container>
    </div>
  </ng-container>

  <ng-template #editForm>
    <div class="admin-form" [formGroup]="userForm">
      <div id="userProfileDetail">
        <div class="form-card">
          <div class="row section-header">
            <span>User Profile</span>
          </div>

          <div class="row">
            <div class="col-md-3 mb-3">
              <label for="firstName">First Name (EN)<span class="text-danger">*</span></label>
              <input
                id="firstName"
                name="firstName"
                class="form-control"
                formControlName="firstName"
                maxlength="100"
                placeholder="First Name (EN)"
                tabindex="1"
                trim="blur"
                [ngClass]="{
                  'is-invalid': submitted && userForm.controls.firstName.errors
                }"
                appPascalCase
                appAlphabetOnly
              />
              <div *ngIf="submitted && userForm.controls.firstName.errors" class="invalid-feedback">
                <div *ngIf="userForm.controls.firstName.errors.required">
                  {{ 'ERRORS.REQUIRED' | translate }}
                </div>
              </div>
            </div>
            <div class="col-md-3 mb-3">
              <label for="lastName">Last Name (EN)<span class="text-danger">*</span></label>
              <input
                id="lastName"
                name="lastName"
                class="form-control"
                formControlName="lastName"
                maxlength="100"
                placeholder="Last Name (EN)"
                tabindex="2"
                trim="blur"
                [ngClass]="{
                  'is-invalid': submitted && userForm.controls.lastName.errors
                }"
                appPascalCase
                appAlphabetOnly
              />
              <div *ngIf="submitted && userForm.controls.lastName.errors" class="invalid-feedback">
                <div *ngIf="userForm.controls.lastName.errors.required">
                  {{ 'ERRORS.REQUIRED' | translate }}
                </div>
              </div>
            </div>
            <div class="col-md-3 mb-3">
              <label for="localFirstName">First Name (Local)<span class="text-danger">*</span></label>
              <input
                id="localFirstName"
                name="localFirstName"
                class="form-control"
                formControlName="localFirstName"
                maxlength="100"
                placeholder="First Name (Local)"
                tabindex="3"
                trim="blur"
                [ngClass]="{
                  'is-invalid': submitted && userForm.controls.localFirstName.errors
                }"
              />
              <div *ngIf="submitted && userForm.controls.localFirstName.errors" class="invalid-feedback">
                <div *ngIf="userForm.controls.localFirstName.errors.required">
                  {{ 'ERRORS.REQUIRED' | translate }}
                </div>
              </div>
            </div>
            <div class="col-md-3 mb-3">
              <label for="localLastName">Last Name (Local)<span class="text-danger">*</span></label>
              <input
                id="localLastName"
                name="localLastName"
                class="form-control"
                formControlName="localLastName"
                maxlength="100"
                placeholder="Last Name (Local)"
                tabindex="4"
                trim="blur"
                [ngClass]="{
                  'is-invalid': submitted && userForm.controls.localLastName.errors
                }"
              />
              <div *ngIf="submitted && userForm.controls.localLastName.errors" class="invalid-feedback">
                <div *ngIf="userForm.controls.localLastName.errors.required">
                  {{ 'ERRORS.REQUIRED' | translate }}
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-3 mb-3">
              <label for="mobileNo">Mobile Phone<span class="text-danger">*</span></label>
              <ngx-intl-tel-input
                [cssClass]="'form-control d-block ' + (isPhoneError(userForm.controls.mobileNo) ? 'is-invalid' : '')"
                [preferredCountries]="['th']"
                [enableAutoCountrySelect]="true"
                [maxlength]="'25'"
                id="mobileNo"
                formControlName="mobileNo"
                tabindex="5"
              >
              </ngx-intl-tel-input>
              <div *ngIf="submitted && userForm.controls.mobileNo.errors" class="invalid-feedback">
                <div *ngIf="userForm.controls.mobileNo.errors?.required; else validatePhoneNumber">
                  {{ 'ERRORS.REQUIRED' | translate }}
                </div>
                <ng-template #validatePhoneNumber>
                  <div *ngIf="userForm.controls.mobileNo.errors?.validatePhoneNumber">
                    {{ 'ERRORS.INVALID_PHONE' | translate }}
                  </div>
                </ng-template>

                <div *ngIf="userForm.controls.mobileNo.errors?.isDuplicatedMobile">
                  {{ 'ERRORS.DUPLICATED_FIELD' | translate: { value: 'Mobile Phone' } }}
                </div>
              </div>
            </div>
            <div class="col-md-3 mb-3">
              <div class="d-flex justify-content-between align-items-center email-label-row">
                <label for="email">Email<span class="text-danger">*</span></label>
                <label class="no-email-label" for="noEmail">
                  <input
                    id="noEmail"
                    data-id="noEmail"
                    name="noEmail"
                    type="checkbox"
                    formControlName="noEmail"
                    (change)="onChangeNoEmail($event.target.checked)"
                  />
                  <span>No Email</span>
                </label>
              </div>
              <input
                id="email"
                name="email"
                type="email"
                class="form-control"
                maxlength="100"
                formControlName="email"
                placeholder="Email"
                tabindex="6"
                trim="blur"
                [ngClass]="{
                  'is-invalid': submitted && userForm.controls.email.errors
                }"
              />
              <div *ngIf="submitted && userForm.controls.email.errors" class="invalid-feedback">
                <div *ngIf="userForm.controls.email.errors?.required; else invalidEmail">
                  {{ 'ERRORS.REQUIRED' | translate }}
                </div>
                <ng-template #invalidEmail>
                  <div *ngIf="userForm.controls.email.errors?.email">
                    {{ 'ERRORS.INVALID_EMAIL' | translate }}
                  </div>
                </ng-template>
              </div>
            </div>
            <div class="col-md-3 mb-3">
              <label for="merchant">Merchant<span class="text-danger">*</span></label>
              <ng-select
                id="merchant"
                [items]="merchantList | async"
                placeholder="Please select..."
                notFoundText="No Data"
                [virtualScroll]="true"
                formControlName="merchant"
                bindLabel="merchantNameDisplay"
                dropdownPosition="auto"
                tabindex="7"
                [loading]="merchantSearchLoading"
                [typeahead]="merchantSearchInput$"
                [ngClass]="{ 'is-invalid': submitted && userForm.controls.merchant.errors }"
                [clearable]="false"
              >
                <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                  <div>
                    <strong>Merchant Name:</strong>
                    <span [ngOptionHighlight]="search" class="ml-1">
                      {{ item.merchantName }}
                    </span>
                  </div>
                  <small>
                    <strong>Tax ID/ID Card:</strong
                    ><span [ngOptionHighlight]="search" class="ml-1">{{ item.taxId }}</span
                    >{{ ' | ' }} <strong>Store Type:</strong
                    ><span [ngOptionHighlight]="search" class="ml-1">{{
                      'STORE_TYPE.' + item.merchantType | translate
                    }}</span>
                  </small>
                </ng-template>
              </ng-select>
              <div *ngIf="submitted && userForm.controls.merchant.errors" class="invalid-feedback">
                <div *ngIf="userForm.controls.merchant.errors.required">
                  {{ 'ERRORS.REQUIRED' | translate }}
                </div>
              </div>
            </div>
            <div class="col-md-3 mb-3">
              <label for="employeeCode">Employee ID<span class="text-danger">*</span></label>
              <input
                id="employeeCode"
                name="employeeCode"
                class="form-control"
                formControlName="employeeCode"
                maxlength="100"
                tabindex="8"
                placeholder="Employee ID"
                [ngClass]="{
                  'is-invalid': submitted && userForm.controls.employeeCode.errors
                }"
              />

              <div *ngIf="submitted && userForm.controls.employeeCode.errors" class="invalid-feedback">
                <div *ngIf="userForm.controls.employeeCode.errors.required">
                  {{ 'ERRORS.REQUIRED' | translate }}
                </div>
              </div>
            </div>
          </div>

          <!--userProfileDetail-->
        </div>

        <div class="form-card">
          <div class="row section-header">
            <span>Department &amp; Roles</span>
          </div>

          <div class="row">
            <div class="col-md-6 mb-3">
              <label for="department">Department<span class="text-danger">*</span></label>
              <ng-select
                #departmentSelect
                id="department"
                data-id="department"
                placeholder="Please select..."
                [items]="departmentOptionsDisplay"
                [searchable]="false"
                [clearable]="false"
                bindLabel="displayName"
                notFoundText="No item found"
                tabindex="9"
                formControlName="department"
                [compareWith]="compareDepartment"
                (change)="onChangeDepartment()"
                [ngClass]="{
                  'is-invalid': submitted && userForm.controls.department.errors
                }"
              >
                <ng-template ng-header-tmp>
                  <input
                    type="text"
                    class="form-control search-box"
                    data-id="departmentSearch"
                    placeholder="Enter keyword search"
                    (input)="departmentSelect.filter($event.target.value)"
                  />
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                  <span [ngOptionHighlight]="search">{{ item.displayName }}</span>
                </ng-template>
              </ng-select>

              <div *ngIf="submitted && userForm.controls.department.errors" class="invalid-feedback">
                <div *ngIf="userForm.controls.department.errors.required">
                  {{ 'ERRORS.REQUIRED' | translate }}
                </div>
                <div *ngIf="userForm.controls.department.errors.isInvalidDepartment">
                  {{ 'ERRORS.INVALID_DEPARTMENT' | translate }}
                </div>
              </div>
            </div>

            <div class="col-md-6 mb-3">
              <label for="roles">Role<span class="text-danger">*</span></label>
              <ng-select
                #roleSelect
                id="roles"
                data-id="roles"
                class="clear-cycle user-tag-select"
                placeholder="Please select..."
                [items]="roleOptions"
                [multiple]="true"
                [closeOnSelect]="true"
                [searchable]="false"
                [clearable]="!roleSearchTerm"
                bindLabel="name"
                notFoundText="No item found"
                tabindex="10"
                formControlName="roles"
                (change)="onChangeRole()"
                (close)="clearRoleSearch()"
                [ngClass]="{
                  'is-invalid': submitted && userForm.controls.roles.errors
                }"
              >
                <ng-template ng-header-tmp>
                  <input
                    type="text"
                    class="form-control search-box"
                    data-id="roleSearch"
                    placeholder="Enter keyword search"
                    [value]="roleSearchTerm"
                    (input)="onSearchRole($event.target.value, roleSelect)"
                  />
                </ng-template>
                <ng-template ng-label-tmp let-item="item" let-clear="clear">
                  <button
                    type="button"
                    class="tag-remove"
                    [attr.aria-label]="'Remove ' + item.name"
                    (mousedown)="$event.stopPropagation()"
                    (click)="clear(item)"
                  >
                    <svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true">
                      <circle cx="7" cy="7" r="7" fill="#fff" />
                      <path
                        d="M4.8 4.8 9.2 9.2M9.2 4.8 4.8 9.2"
                        stroke="#5e646e"
                        stroke-width="1.7"
                        stroke-linecap="round"
                      />
                    </svg>
                  </button>
                  <span class="ng-value-label">{{ item.name }}</span>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                  <span [ngOptionHighlight]="search">{{ item.name }}</span>
                </ng-template>
              </ng-select>

              <div *ngIf="submitted && userForm.controls.roles.errors" class="invalid-feedback">
                <div *ngIf="userForm.controls.roles.errors.required">
                  {{ 'ERRORS.REQUIRED' | translate }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <ng-container *ngIf="hasStoreAuthority">
          <div class="form-card">
            <div class="row section-header">
              <span>Store Authority</span>
            </div>

            <div class="row">
              <div class="col-md-6 mb-3">
                <label for="authority-level">Authority Level<span class="text-danger">*</span></label>
                <ng-select
                  id="authority-level"
                  data-id="authorityLevel"
                  placeholder="Please select..."
                  [items]="authorityLevelOptions"
                  [searchable]="false"
                  [clearable]="false"
                  bindLabel="label"
                  bindValue="value"
                  tabindex="11"
                  formControlName="authorityLevel"
                  (change)="onChangeAuthorityLevel()"
                  [ngClass]="{
                    'is-invalid': submitted && userForm.controls.authorityLevel.errors
                  }"
                >
                </ng-select>

                <div *ngIf="submitted && userForm.controls.authorityLevel.errors" class="invalid-feedback">
                  <div *ngIf="userForm.controls.authorityLevel.errors.required">
                    {{ 'ERRORS.REQUIRED' | translate }}
                  </div>
                </div>
              </div>

              <div class="col-md-6 mb-3">
                <label for="authority-scope">Authority Scope<span class="text-danger">*</span></label>
                <div class="authority-scope-container">
                  <ng-select
                    #scopeSelect
                    id="authority-scope"
                    data-id="authorityScope"
                    class="clear-cycle user-tag-select"
                    [placeholder]="authorityScopePlaceholder"
                    [items]="authorityScopeOptions"
                    [multiple]="true"
                    [closeOnSelect]="true"
                    [searchable]="false"
                    [clearable]="true"
                    bindLabel="displayName"
                    notFoundText="No item found"
                    tabindex="12"
                    formControlName="authorityScope"
                    [ngClass]="{
                      'is-invalid': submitted && userForm.controls.authorityScope.errors
                    }"
                  >
                    <ng-template ng-header-tmp>
                      <input
                        type="text"
                        class="form-control search-box"
                        data-id="authorityScopeSearch"
                        placeholder="Enter keyword search"
                        (input)="scopeSelect.filter($event.target.value)"
                      />
                    </ng-template>
                    <ng-template ng-label-tmp let-item="item" let-clear="clear">
                      <button
                        type="button"
                        class="tag-remove"
                        [attr.aria-label]="'Remove ' + item.displayName"
                        (mousedown)="$event.stopPropagation()"
                        (click)="clear(item)"
                      >
                        <svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true">
                          <circle cx="7" cy="7" r="7" fill="#fff" />
                          <path
                            d="M4.8 4.8 9.2 9.2M9.2 4.8 4.8 9.2"
                            stroke="#5e646e"
                            stroke-width="1.7"
                            stroke-linecap="round"
                          />
                        </svg>
                      </button>
                      <span class="ng-value-label">{{ item.displayName }}</span>
                      <button
                        *ngIf="!isStoreLevel"
                        type="button"
                        class="scope-store-badge"
                        [attr.data-id]="'scopeStoreBadge-' + item.code"
                        (mousedown)="$event.stopPropagation()"
                        (click)="openStorePanel(item, $event, scopeSelect)"
                      >
                        {{ item.totalStore || 0 }} stores ›
                      </button>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                      <span class="scope-option">
                        <span class="scope-option-code" [ngOptionHighlight]="search">{{ item.code }}</span>
                        <span class="scope-option-name" [ngOptionHighlight]="search">{{ item.name }}</span>
                      </span>
                    </ng-template>
                  </ng-select>

                  <app-authority-scope-store-panel
                    *ngIf="storePanelScope"
                    class="authority-scope-panel"
                    [scopeName]="storePanelScope.displayName"
                    [stores]="storePanelStores"
                    (closed)="closeStorePanel()"
                  ></app-authority-scope-store-panel>
                </div>

                <div *ngIf="submitted && userForm.controls.authorityScope.errors" class="invalid-feedback">
                  <div *ngIf="userForm.controls.authorityScope.errors.required">
                    {{ 'ERRORS.REQUIRED' | translate }}
                  </div>
                </div>

                <div
                  *ngIf="authorityScopeError && userForm.controls.authorityScope.enabled"
                  class="authority-error authority-error-inline"
                  data-id="authorityScopeError"
                >
                  <span class="authority-error-message">
                    <svg class="authority-error-icon" width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
                      <circle cx="8" cy="8" r="7" fill="none" stroke="currentColor" stroke-width="1.5" />
                      <path d="M8 4.5v4.2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
                      <circle cx="8" cy="11.3" r="0.9" fill="currentColor" />
                    </svg>
                    Unable to load authority scopes. Please try again.
                  </span>
                  <button
                    type="button"
                    class="btn btn-standard authority-error-retry"
                    data-id="authorityScopeRetry"
                    (click)="retryLoadAuthorityScopes()"
                  >
                    Retry
                  </button>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-template>

  <!--footer-->
  <div class="fixed-row-bottom form-row">
    <div class="float-left"></div>

    <div class="float-right">
      <button
        *ngIf="isViewMode && hasManagePermission"
        type="button"
        id="btn-request-edit"
        class="btn btn-primary"
        (click)="toggleToEditMode()"
      >
        Edit
      </button>
      <button
        *ngIf="!isViewMode && hasManagePermission"
        type="button"
        id="btn-cancel"
        class="btn btn-standard mr-2"
        (click)="onExit()"
      >
        Cancel
      </button>
      <button
        *ngIf="!isViewMode && hasManagePermission"
        type="button"
        id="btn-submit"
        (click)="onSubmit()"
        class="btn btn-primary"
      >
        Submit
      </button>
    </div>
  </div>
  <!--End footer-->
</div>
